import { VRProp } from './props.js';
import { CAUI } from 'ca-ui';
import { VRTooltip } from './tooltip.js';

export class VRPerson extends VRProp {
  constructor (vr, scene, options) {
    super(vr, scene, options);

    this.scene = scene;
    if (this.options.rotation == null) this.options.rotation = 0;

    super.setType('prop_person');
    if (!this.options.propId) this.setAsset(vr.assets.people[0]);
    if (this.options.age) { this.setScale(CAUI.scale(this.options.age, 0, 20, 30, 100)); }

    this.tooltip = new VRTooltip({
      position: 'top',
      size: 'md',
      strokeWidth: 2,
      corner: 8
    });
    this.div.append(this.tooltip.div);
    this.type = 'person';
    this.setScale(this.options.scale);
  }

  setAsset (asset) {
    this.options.age = asset.age;
    super.setAsset(asset);
  }

  setScale () {
    if (this.options.age) { this.options.scale = CAUI.scale(this.options.age, 0, 20, 30, 100); }
    super.setScale(this.options.scale);
  }

  setPropId (propId) {
    super.setPropId(propId);
    this.setImage(
      this.scene.parseMediaUrl(
        'https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/people/person_' +
          propId +
          '_{daynight}_' +
          CAUI.zeroPad(this.options.rotation, 2) +
          '.png'
      )
    );
  }

  setTooltipText (tooltipText) {
    this.tooltipText = tooltipText;
    this.tooltip.setText(tooltipText);
    this.tooltip.layout();
    // this.overlayHeading.text(this.say);
  }

  getTooltipText () {
    return this.tooltipText;
  }

  setRotation (rotation) {
    this.options.rotation = rotation;
    this.setPropId(this.options.propId);
  }

  getRotation () {
    return this.options.rotation;
  }
}
